import { AssessmentSubType, AssessmentSubTypeDescription } from '../../enums/assessment-type';

export function getAssessmentSubTypeDescription(assessmentSubType: AssessmentSubType): AssessmentSubTypeDescription {
  return AssessmentSubTypeDescription[AssessmentSubType[assessmentSubType] as keyof typeof AssessmentSubTypeDescription] || assessmentSubType;
}
